<section class="service_sec award" id="award" data-scroll-section>
  <div
    class="img_wraper"
    data-scroll
    data-scroll-repeat
    data-scroll-sticky
    data-scroll-target="#award"
  >
    <span data-scroll data-scroll-speed="1.5">
      <figure
        class="section_img lazyloaded"
        style="background-image: url('assets/about-page/award_sec.jpg')"
      ></figure>
    </span>
  </div>
  <div class="row">
    <div class="content_div award_div" data-scroll data-scroll-speed="1">
      <div class="sec_head">
        <h2>Skills</h2>
      </div>
      <p>
        With over 4 years of experience as a full-stack developer, I’ve worked with global agencies
        and startups to build fast, responsive, and user-friendly web applications. I focus on clean
        code, scalable architecture, and best development practices.
      </p>
      <p>
        My core strength lies in frontend development using HTML, CSS, JavaScript, TypeScript,
        Angular, Vue.js, and React. I’ve built custom components, responsive layouts, and seamless
        UI experiences that perform well across all devices.
      </p>
      <p>
        On the backend, I work with Node.js, ExpressJS, MongoDB, MySQL, PostgreSQL, and Firebase,
        creating secure APIs and integrating cloud services like AWS and Docker. This full-stack
        capability allows me to deliver complete solutions — from UI to infrastructure — tailored to
        business needs.
      </p>
    </div>
    <div class="col_item">
      <div class="col-lg-6 skills-content">
        <div class="d-flex w-100 gap-3">
          <div class="d-flex flex-column align-items-center skill-img-title">
            <img src="assets/about-page/angular.svg" alt="angular" />
            <span class="d-block">Angular</span>
          </div>
          <div class="progress">
            <div class="progress-bar-container">
              <div class="progress-bar" style="width: 92%">92%</div>
            </div>
          </div>
        </div>
        <div class="d-flex w-100 gap-3">
          <div class="d-flex flex-column align-items-center skill-img-title">
            <img src="assets/about-page/data-bage.png" alt="data-bage" />
            <span class="d-block">Data Base</span>
          </div>
          <div class="progress">
            <div class="progress-bar-container">
              <div class="progress-bar" style="width: 85%">85%</div>
            </div>
          </div>
        </div>
        <div class="d-flex w-100 gap-3">
          <div class="d-flex flex-column align-items-center skill-img-title">
            <img src="assets/about-page/nodejs.svg" alt="nodejs" />
            <span class="d-block">Node JS</span>
          </div>
          <div class="progress">
            <div class="progress-bar-container">
              <div class="progress-bar" style="width: 92%">92%</div>
            </div>
          </div>
        </div>
        <div class="d-flex w-100 gap-3">
          <div class="d-flex flex-column align-items-center skill-img-title">
            <img src="assets/about-page/iconic.png" alt="iconic" />
            <span class="d-block">Ionic</span>
          </div>
          <div class="progress">
            <div class="progress-bar-container">
              <div class="progress-bar" style="width: 90%">90%</div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6 skills-content">
        <div class="d-flex w-100 gap-3">
          <div class="d-flex flex-column align-items-center skill-img-title">
            <img src="assets/about-page/unit-testing.png" alt="unit-testing" />
            <span class="d-block">Unit Testing</span>
          </div>
          <div class="progress">
            <div class="progress-bar-container">
              <div class="progress-bar" style="width: 95%">95%</div>
            </div>
          </div>
        </div>
        <div class="d-flex w-100 gap-3">
          <div class="d-flex flex-column align-items-center skill-img-title">
            <img src="assets/about-page/typescript.svg" alt="typescript" />
            <span class="d-block">Typescript</span>
          </div>
          <div class="progress">
            <div class="progress-bar-container">
              <div class="progress-bar" style="width: 90%">90%</div>
            </div>
          </div>
        </div>
        <div class="d-flex w-100 gap-3">
          <div class="d-flex flex-column align-items-center skill-img-title">
            <img src="assets/about-page/pm.png" alt="pm" />
            <span class="d-block text-center text-wrap">Project Management</span>
          </div>
          <div class="progress">
            <div class="progress-bar-container">
              <div class="progress-bar" style="width: 85%">85%</div>
            </div>
          </div>
        </div>
        <div class="d-flex w-100 gap-3">
          <div class="d-flex flex-column align-items-center skill-img-title">
            <img src="assets/about-page/electron.png" alt="electron" />
            <span class="d-block">Electron</span>
          </div>
          <div class="progress">
            <div class="progress-bar-container">
              <div class="progress-bar" style="width: 90%">90%</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
